<div class="confirmation-container">
    <mat-card>
        <mat-card-content>
            <div class="confirmation-title">
                <h3>
                    Your form has been submitted!
                </h3>
            </div>
            <div class="confirmation-body">
                <p>
                    Your reference number is <b class="confirmation-reference">{{ReferenceNumber}}</b>.
                </p>
                <p>
                    Click Login to go back to the main page.
                </p>
            </div>
            <div class="confirmation-footer">
                <button mat-flat-button
                    (click)="OnClickRedirectToLogin()"
                    class="mat-flat-button mat-primary">
                    Login
                </button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
